<template>
  <v-container>
    <!--    Diálogo Reportes de Nomina   -->
    <v-dialog v-model="dialogGeneratePayrollReport" scrollable persistent width="600px">
      <v-card :loading="loadingDataHealthByTeacherPayrollRecords">
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            {{$t('payroll_report')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
              class="align-self-end"
              color="red"
              icon
              @click="clearPayrollReport(), dialogGeneratePayrollReport = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-autocomplete
                  class="mt-3 mb-1 ml-1 mr-1"
                  v-model="section2"
                  outlined
                  :placeholder="$t('placeholder_choose_section')"
                  prepend-inner-icon="mdi-account-details"
                  name="section2"
                  item-text="name"
                  item-value="section"
                  :label="$t('section')"
                  :items="sections"
                  no-data-text="Ningún Resultado"
                  clearable
              >
                <template v-slot:selection="data">
                  <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      @click="data.select"
                  >
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.name"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex xs4>
              <v-menu
                  v-model="calendarioPayrollInitial"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                      v-model="computedPayrollInitialDateFormatted"
                      :label="$t('initialDate')"
                      hint="DD/MM/YYYY"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      name="datePayrollInitial"
                      readonly
                      v-on="on"
                      outlined
                      :error-messages="errores.datePayrollInitial"
                  ></v-text-field>
                </template>
                <v-date-picker
                    :locale="$t('region')"
                    v-model="datePayrollInitial"
                    @input="calendarioPayrollInitial = false">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4>
              <v-menu
                  v-model="calendarioPayrollFinal"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                      v-model="computedPayrollFinalDateFormatted"
                      prepend-icon="mdi-calendar"
                      name="datePayrollFinal"
                      :label="$t('finalDate')"
                      readonly
                      hint="DD/MM/YYYY"
                      persistent-hint
                      v-on="on"
                      outlined
                      :error-messages="errores.datePayrollFinal"
                  ></v-text-field>
                </template>
                <v-date-picker
                    :locale="$t('region')"
                    v-model="datePayrollFinal"
                    @input="calendarioPayrollFinal = false">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4>
              <v-btn
                  :disabled="section2 === null || section2 === undefined"
                  block
                  color="primary"
                  @click="submitPayroll"
              >
                {{$t('Filtrar')}}
              </v-btn>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-spacer/><br>
          <v-layout row wrap>
            <v-flex v-if="healthByTeacherPayrollRecords.length > 0" class="text-center">
              <v-btn
                  v-show="healthByTeacherPayrollRecords.length > 0"
                  color="secondary"
                  block
                  :loading="loading"
                  @click="extra"
              >
                {{$t('export_to_pdf')}}
              </v-btn>
            </v-flex>
            <v-flex v-else class="text-center">
              {{$t('no_registros')}}
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <v-layout calign-center >
      <v-flex>
        <v-card class="elevation-5">
          <v-card-text>
            <h3>{{$t('mostrando_historial_dia')}} </h3>
            <v-form
                @submit.prevent="submit()">
              <v-layout class="align-center " row wrap>
                <v-flex xs12 md6>
                  <v-menu
                      v-model="calendario"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                          v-model="computedInitialDateFormatted"
                          :label="$t('initialDate')"
                          hint="DD/MM/YYYY"
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          name="date"
                          readonly
                          v-on="on"
                          :error-messages="errores.date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        :locale="$t('region')"
                        v-model="date"
                        @input="calendario = false">
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md6>
                  <v-menu
                      v-model="calendario2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                          v-model="computedFinalDateFormatted"
                          prepend-icon="mdi-calendar"
                          name="date2"
                          :label="$t('finalDate')"
                          readonly
                          hint="DD/MM/YYYY"
                          persistent-hint
                          v-on="on"
                          :error-messages="errores.date2"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        :locale="$t('region')"
                        v-model="date2"
                        @input="calendario2 = false">
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <br>
                <v-flex xs6>
                  <v-btn
                      color="primary"
                      type="submit"
                      large
                  >{{ $t('Filtrar') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>
            <br>
            <v-layout>
              <v-flex>
                <v-card class="elevation-5">
                  <v-toolbar dark color="primary">
                    <v-toolbar-title>
                      {{$t('health_format')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout class="my-4" align-center justify-center fill-height>
                      <v-flex>
                        <v-card-title>
                          <v-layout row wrap>
                            <v-flex xs12 sm4>
                              <v-autocomplete
                                  class="mt-1 mb-1 ml-1 mr-1"
                                  v-model="classroom"
                                  outlined
                                  :placeholder="$t('classrooms')"
                                  prepend-inner-icon="mdi-google-classroom"
                                  name="classroom"
                                  item-text="name"
                                  item-value="fullname"
                                  :label="$t('classroom')"
                                  :items="classrooms"
                                  no-data-text="Ningún Resultado"
                                  clearable
                              >
                                <template v-slot:selection="data">
                                  <v-chip
                                      v-bind="data.attrs"
                                      :input-value="data.selected"
                                      @click="data.select"
                                  >
                                    {{ data.item.fullname }}
                                  </v-chip>
                                </template>
                                <template v-slot:item="data">
                                  <template v-if="typeof data.item !== 'object'">
                                    <v-list-item-content v-text="data.item"></v-list-item-content>
                                  </template>
                                  <template v-else>
                                    <v-list-item-content>
                                      <v-list-item-title v-html="data.item.fullname"></v-list-item-title>
                                    </v-list-item-content>
                                  </template>
                                </template>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm8>
                              <v-text-field
                                  class="mt-1 mb-1 ml-1 mr-1"
                                  outlined
                                  clearable
                                  v-model="searchStundetsTutors"
                                  append-icon="mdi-magnify"
                                  :label="$t('Buscar')"
                                  :placeholder="$t('placeholder_student_tutors')"
                                  single-line
                                  hide-details
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-card-title>
                        <v-btn
                            v-show="healthRecords.length > 0"
                            color="primary"
                            @click="exportPdfHealthFormat"
                        >
                          {{$t('export_to_pdf')}}
                        </v-btn>
                        <v-data-table
                            :headers="headersHealthRecords"
                            :loading="loadingDataHealthRecords"
                            :items="healthRecords"
                            :search="searchStundetsTutors"
                            multi-sort
                            @current-items="getFiltered"
                            :footer-props="{
                                itemsPerPageOptions: [
                                    {text: this.$t('todos'), value: -1}
                                ],
                                itemsPerPageText: $t('filas_por_pagina')
                            }"
                            class="elevation-1"
                            :no-data-text="$t('no_registros')"
                        >
                          <template v-slot:item.temperature="{ item }">
                            {{item.temperature === ''|| item.temperature === null ? $t('sin_registrar') : item.temperature}}
                          </template>
                          <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                          </template>
                          <template v-slot:no-results>
                            <v-alert type="warning">
                              {{$t('ningun_resultado_1')}} "{{ searchStundetsTutors }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <br>
            <v-layout>
              <v-flex>
                <v-card class="elevation-5">
                  <v-toolbar dark color="primary">
                    <v-toolbar-title>
                      {{$t('health_format')}} {{$t('teacher')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout class="text-center" align-center justify-center fill-height>
                      <v-flex>
                        <v-card-title>
                          <v-layout row wrap>
                            <v-flex xs12 sm4>
                              <v-autocomplete
                                  class="mt-1 mb-1 ml-1 mr-1"
                                  v-model="section"
                                  outlined
                                  :placeholder="$t('placeholder_choose_section')"
                                  prepend-inner-icon="mdi-account-details"
                                  name="section"
                                  item-text="name"
                                  item-value="section"
                                  :label="$t('section')"
                                  :items="sections"
                                  no-data-text="Ningún Resultado"
                                  clearable
                              >
                                <template v-slot:selection="data">
                                  <v-chip
                                      v-bind="data.attrs"
                                      :input-value="data.selected"
                                      @click="data.select"
                                  >
                                    {{ data.item.name }}
                                  </v-chip>
                                </template>
                                <template v-slot:item="data">
                                  <template v-if="typeof data.item !== 'object'">
                                    <v-list-item-content v-text="data.item"></v-list-item-content>
                                  </template>
                                  <template v-else>
                                    <v-list-item-content>
                                      <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                    </v-list-item-content>
                                  </template>
                                </template>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm8>
                              <v-text-field
                                  class="mt-1 mb-1 ml-1 mr-1"
                                  outlined
                                  clearable
                                  v-model="search"
                                  append-icon="mdi-magnify"
                                  :label="$t('Buscar')"
                                  :placeholder="$t('placeholder_invitados2')"
                                  single-line
                                  hide-details
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-card-title>
                        <v-btn
                            v-show="healthByTeacherRecords.length > 0"
                            color="primary"
                            @click="exportPdfHealthByTeacherFormat"
                        >
                          {{$t('export_to_pdf')}}
                        </v-btn>
                        <vue-excel-xlsx
                                :data="healthByTeacherRecords"
                                :columns="headersHealthByTeacherRecordsExcel"
                                :filename="'healthByTeacher' + '_' + date + '_' + date2"
                                sheetname="healthByTeacher"
                        >
                            <v-btn
                                v-show="healthByTeacherRecords.length > 0"
                                color="primary"
                            >
                                {{$t('export_to_excel')}}
                            </v-btn>
                        </vue-excel-xlsx>
                        <v-btn
                            color="primary"
                            @click="getSchoolData(), section2 = null, dialogGeneratePayrollReport = true"
                        >
                          {{$t('generate_payroll_report')}}
                        </v-btn>
                        <v-data-table
                            :headers="headersHealthByTeacherRecords"
                            :loading="loadingDataHealthByTeacherRecords"
                            :items="healthByTeacherRecords"
                            :search="search"
                            multi-sort
                            @current-items="getFiltered2"
                            :footer-props="{
                                itemsPerPageOptions: [
                                    {text: this.$t('todos'), value: -1}
                                ],
                                itemsPerPageText: $t('filas_por_pagina')
                            }"
                            class="elevation-1"
                            :no-data-text="$t('no_registros')"
                        >
                          <template v-slot:item.nss="{ item }">
                            {{item.nss === '' || item.nss === null ? $t('sin_registrar') : item.nss}}
                          </template>
                          <template v-slot:item.temperature="{ item }">
                            {{item.temperature === ''|| item.temperature === null ? $t('sin_registrar') : item.temperature}}
                          </template>
                          <template v-slot:item.check_in_time="{ item }">
                            {{item.check_in_time === ''|| item.check_in_time === null ? $t('sin_registrar') : item.check_in_time}}
                          </template>
                          <template v-slot:item.check_out_time="{ item }">
                            {{item.check_out_time === ''|| item.check_out_time === null ? $t('sin_registrar') : item.check_out_time}}
                          </template>
                          <template v-slot:pageText="props">
                            {{props.rowsPerPage}}s
                            {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                          </template>
                          <template v-slot:no-results>
                            <v-alert type="warning">
                              {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import store from '@/store'
import {HTTP} from '@/main.js'
import jsPDF from 'jspdf'
import 'jspdf-autotable'


export default {
  name: "health2",
  data: () => ({
    calendario: '',
    calendarioPayrollInitial: '',
    datePayrollInitial: '',
    date: '',
    calendario2: '',
    calendarioPayrollFinal: '',
    datePayrollFinal: '',
    date2: '',
    errores: [],
    fecha_actual: '',
    yyyy: '',
    mm: '',
    dd: '',
    yyyy2: '',
    mm2: '',
    dd2: '',
    yyyyPayrollInitial: '',
    mmPayrollInitial: '',
    ddPayrollInitial: '',
    yyyyPayrollFinal: '',
    mmPayrollFinal: '',
    ddPayrollFinal: '',
    headersHealthRecords: [],
    loadingDataHealthRecords: false,
    healthRecords: [],
    headersHealthByTeacherRecords: [],
    headersHealthByTeacherPayrollRecords: [],
    headersHealthByTeacherRecordsExcel: [],
    loadingDataHealthByTeacherRecords: false,
    loadingDataHealthByTeacherPayrollRecords: false,
    healthByTeacherRecords: [],
    healthByTeacherPayrollRecords: [],
    aux: [],
    search: '',
    searchStundetsTutors: '',
    sections: [
      { header: 'Secciones'},
      { name: 'Kinder', section: 'kinder'},
      { name: 'Primaria', section: 'primaria'},
      { name: 'Secundaria', section: 'secundaria'},
      { name: 'Preparatoria', section: 'preparatoria'},
      { name: 'Administrativo', section: 'administrativo'},
      { name: 'Desconocido', section: 'desconocido'}
    ],
    section: null,
    section2: null,
    classrooms: [],
    classroom: null,
    aux2: [],
    teachers: [],
    idTeacher: null,
    loadingTeachers: false,
    dialogGeneratePayrollReport: false,
    loading: false,
    tolerance: 1,
    dataSchool: {},
    generate_payroll_report: false
  }),
  created () {
    this.fecha_actual = this.get_current_date()
    this.date = this.datePayrollInitial = this.fecha_actual
    this.date2 = this.datePayrollFinal = this.fecha_actual
    this.getClassrooms()
    this.getTeachers()
    this.getHealthRecords(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
    this.getHealthByTeacherRecords(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
  },
  beforeUpdate () {
    this.headersHealthRecords = [
      {
        text: this.$t('estudiante'),
        align: 'center',
        sortable: true,
        value: 'fullname_student'
      },
      {
        text: 'Tutor',
        align: 'center',
        sortable: true,
        value: 'fullname_tutor'
      },
      {
        text: this.$t('classroom'),
        align: 'center',
        sortable: true,
        value: 'classroom',
        filter: this.classroomFilter
      },
      {
        text: this.$t('date'),
        align: 'center',
        sortable: true,
        value: 'date'
      },
      {
        text: this.$t('temperature'),
        align: 'center',
        sortable: true,
        value: 'temperature'
      }
    ]
    this.headersHealthByTeacherRecords = [
      {
        text: this.$t('section'),
        align: 'center',
        sortable: true,
        value: 'section',
        filter: this.sectionFilter
      },
      {
        text: 'NSS',
        align: 'center',
        sortable: true,
        value: 'nss'
      },
      {
        text: this.$t('teacher'),
        align: 'center',
        sortable: true,
        value: 'fullname_teacher'
      },
      {
        text: this.$t('date'),
        align: 'center',
        sortable: true,
        value: 'date'
      },
      {
        text: this.$t('check_in_time'),
        align: 'center',
        sortable: true,
        value: 'check_in_time'
      },
      {
        text: this.$t('check_out_time'),
        align: 'center',
        sortable: true,
        value: 'check_out_time'
      },
      {
        text: this.$t('temperature'),
        align: 'center',
        sortable: true,
        value: 'temperature'
      }
    ]
    this.headersHealthByTeacherPayrollRecords = [
      {
        text: this.$t('date'),
        align: 'center',
        sortable: true,
        value: 'date'
      },
      {
        text: this.$t('day'),
        align: 'center',
        sortable: true,
        value: 'day'
      },
      {
        text: 'Delay',
        align: 'center',
        sortable: true,
        value: 'delay'
      },
      {
        text: this.$t('check_in_time'),
        align: 'center',
        sortable: true,
        value: 'check_in_time'
      },
      {
        text: this.$t('check_out_time'),
        align: 'center',
        sortable: true,
        value: 'check_out_time'
      },
      {
        text: this.$t('temperature'),
        align: 'center',
        sortable: true,
        value: 'temperature'
      }
    ]
    this.headersHealthByTeacherRecordsExcel = [
      {
        label: this.$t('section'),
        field: 'section'
      },
      {
        label: 'ID',
        field: 'idUser'
      },
      {
        label: 'NSS',
        dataFormat: this.boolFormat,
        field: 'nss'
      },
      {
        label: this.$t('teacher'),
        field: 'fullname_teacher'
      },
      {
        label: this.$t('date'),
        field: 'date'
      },
      {
        label: this.$t('check_in_time'),
        dataFormat: this.boolFormat,
        field: 'check_in_time'
      },
      {
        label: this.$t('check_out_time'),
        dataFormat: this.boolFormat,
        field: 'check_out_time'
      },
      {
        label: this.$t('temperature'),
        dataFormat: this.boolFormat,
        field: 'temperature'
      }
    ]
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language']),
    computedInitialDateFormatted () {
      return this.formatDate(this.date)
    },
    computedPayrollInitialDateFormatted () {
      return this.formatDate(this.datePayrollInitial)
    },
    computedFinalDateFormatted () {
      return this.formatDate(this.date2)
    },
    computedPayrollFinalDateFormatted () {
      return this.formatDate(this.datePayrollFinal)
    }
  },
  methods: {
    generatePayrollReport () {
      this.dialogGeneratePayrollReport = false
    },
    example: item => (item.idUser.first_name === null ? 'n/a' : item.idUser.first_name) + ' ' + (item.idUser.last_name === null ? 'n/a' : item.idUser.last_name),
    customFilterTeacher(item, queryText) {
      const textOne = item.idUser.first_name.toLowerCase()
      const textTwo = item.idUser.last_name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
    },
    getTeachers () {
      this.loadingTeachers = true
      HTTP.get('teacher/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.teachers = response.data
        this.loadingTeachers = false
      })
      .catch(error => {
        console.log(error)
        this.loadingTeachers = false
        // console.log(error)
      })
    },
    getSchoolData () {
      HTTP.get('school_payroll/' + this.getProfile.idSchool, {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.tolerance = response.data.tolerance
        this.dataSchool = response.data
        console.log('Toleracncia = ', this.tolerance)
      })
      .catch(error => {
        console.log(error)
      })
    },
    boolFormat(value){
        if (value === '' || value === null)
            return  this.$t('sin_registrar')
        return value
    },
    getFiltered(e){
      // console.log(e) //output the filtered items
      this.aux = e
    },
    getFiltered2(e){
      // console.log(e) //output the filtered items
      this.aux2 = e
    },
    get_current_date () {
      var today = new Date()
      this.dd = today.getDate()
      this.mm = today.getMonth() + 1
      this.yyyy = today.getFullYear()
      this.dd2 = today.getDate()
      this.mm2 = today.getMonth() + 1
      this.yyyy2 = today.getFullYear()

      if (this.dd < 10) {
        this.dd = '0' + this.dd
      }
      if (this.dd2 < 10) {
        this.dd2 = '0' + this.dd2
      }
      if (this.mm < 10) {
        this.mm = '0' + this.mm
      }
      if (this.mm2 < 10) {
        this.mm2 = '0' + this.mm2
      }
      today = this.yyyy + '-' + this.mm + '-' + this.dd
      return today
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    getClassrooms () {
      HTTP.get('classroom/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.classrooms = response.data
        if (this.classrooms.length > 0){
          for (let i = 0; i < this.classrooms.length; i++) {
            console.log(this.classrooms[i].grade_name + ' '+ this.classrooms[i].name)
            this.classrooms[i].fullname = this.classrooms[i].grade_name + ' '+ this.classrooms[i].name
          }
          // console.log('Hola')
          console.log(this.classrooms)
        }
      })
      .catch(e => {
        console.log(e)
      })
    },
    getBase64(url) {
      return HTTP
          .get(url, {
            responseType: 'arraybuffer'
          })
          .then(response => Buffer.from(response.data, 'binary').toString('base64'))
    },
    getHealthRecords (yyyy, mm, dd, yyyy2, mm2, dd2) {
      console.log(yyyy, mm, dd, '-', yyyy2, mm2, dd2)
      this.loadingDataHealthRecords = true
      HTTP.get('health/hitorical/' + yyyy + '/' + mm + '/' + dd + '/' + yyyy2 + '/' + mm2 + '/' + dd2 + '/', {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        console.log(response)
        if (response.status === 204) {
          this.healthRecords = []
        } else {
          this.healthRecords  = response.data
        }
        this.loadingDataHealthRecords = false
      })
      .catch(error => {
        this.loadingDataHealthRecords = false
        console.log(error)
      })
    },
    getHealthByTeacherRecords (yyyy, mm, dd, yyyy2, mm2, dd2) {
      console.log(yyyy, mm, dd, '-', yyyy2, mm2, dd2)
      this.loadingDataHealthByTeacherRecords = true
      HTTP.get('health_by_teacher/hitorical/' + yyyy + '/' + mm + '/' + dd + '/' + yyyy2 + '/' + mm2 + '/' + dd2 + '/', {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        console.log(response)
        if (response.status === 204) {
          this.healthByTeacherRecords = []
        } else {
          this.healthByTeacherRecords  = response.data
        }
        this.loadingDataHealthByTeacherRecords = false
      })
      .catch(error => {
        this.loadingDataHealthByTeacherRecords = false
        console.log(error)
      })
    },
    getHealthByTeacherPayrollRecords (yyyy, mm, dd, yyyy2, mm2, dd2) {
      console.log(yyyy, mm, dd, '-', yyyy2, mm2, dd2)
      this.loadingDataHealthByTeacherPayrollRecords = true
      HTTP.get('health_by_teacher/payroll_by_section/' + this.section2 + '/' + yyyy + '/' + mm + '/' + dd + '/' + yyyy2 + '/' + mm2 + '/' + dd2 + '/', {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        console.log(response)
        if (response.status === 204) {
          this.healthByTeacherPayrollRecords = []
        } else {
          this.healthByTeacherPayrollRecords  = response.data
        }
        this.loadingDataHealthByTeacherPayrollRecords = false
      })
      .catch(error => {
        this.loadingDataHealthByTeacherPayrollRecords = false
        console.log(error)
      })
    },
    split_date (date, date2) {
      var arr = date.split('-')
      var arr2 = date2.split('-')

      this.yyyy = arr[0]
      this.mm = arr[1]
      this.dd = arr[2]

      this.yyyy2 = arr2[0]
      this.mm2 = arr2[1]
      this.dd2 = arr2[2]
    },
    split_date_payroll (date, date2) {
      var arr = date.split('-')
      var arr2 = date2.split('-')

      this.yyyyPayrollInitial= arr[0]
      this.mmPayrollInitial = arr[1]
      this.ddPayrollInitial= arr[2]

      this.yyyyPayrollFinal = arr2[0]
      this.mmPayrollFinal = arr2[1]
      this.ddPayrollFinal = arr2[2]
    },
    submit () {
      this.split_date(this.date, this.date2)
      this.getHealthRecords(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
      this.getHealthByTeacherRecords(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
    },
    submitPayroll () {
      this.split_date_payroll(this.datePayrollInitial, this.datePayrollFinal)
      this.getHealthByTeacherPayrollRecords(this.yyyyPayrollInitial, this.mmPayrollInitial, this.ddPayrollInitial, this.yyyyPayrollFinal, this.mmPayrollFinal, this.ddPayrollFinal)
    },
    exportPdfHealthFormat () {
      var fechaInicial = this.formatDate(this.date)
      var fechaFinal = this.formatDate(this.date2)
      var headerInvitationSent = this.$t('headerHealthFormatSent')
      var period = this.$t('period')
      var al = this.$t('al')
      var page = this.$t('page')
      var de = this.$t('de')
      var temperature = this.$t('sin_registrar')
      // var headerDate = this.$t('fecha_hora')
      var columns = [{
        fullname_student: this.$t('estudiante'),
        fullname_tutor: 'Tutor',
        classroom: this.$t('classroom'),
        date: this.$t('date'),
        temperature: this.$t('temperature'),
      }]
      var doc = new jsPDF("portrait", "pt", "letter")
      var totalPagesExp = '{total_pages_count_string}'
      doc.autoTable({
        head: columns,
        body: this.aux,
        didDrawPage: function (data) {
          // Header
          doc.setFontSize(20)
          doc.setTextColor(40)
          doc.setFontStyle('normal')
          // if (base64Img) {
          //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
          // }
          doc.text(headerInvitationSent, data.settings.margin.left + 20, 38)
          doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)

          // Footer
          var str = page + doc.internal.getNumberOfPages()
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === 'function') {
            str = str + de + totalPagesExp
          }
          doc.setFontSize(10)

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        allSectionHooks: true,
        didParseCell: function (data) {
          if (data.row.section === 'body') {
            if (data.column.index === 4) {
              if(data.cell.text.toString() === '' || data.cell.text.toString() === ' ' || data.cell.text.toString() === null){
                data.cell.text = temperature
              }
            }
          }
        },
        margin: { top: 80 }
      })
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      doc.save('healthFormat' + '_' + this.date + '_' + this.date2 + '.pdf')
    },
    exportPdfHealthByTeacherFormat () {
      var fechaInicial = this.formatDate(this.date)
      var fechaFinal = this.formatDate(this.date2)
      var headerInvitationSent = this.$t('headerHealthFormatSent')
      var period = this.$t('period')
      var al = this.$t('al')
      var page = this.$t('page')
      var de = this.$t('de')
      var temperature = this.$t('sin_registrar')
      // var headerDate = this.$t('fecha_hora')
      var columns = [{
        section: this.$t('section'),
        nss: 'NSS',
        fullname_teacher: this.$t('teacher'),
        date: this.$t('date'),
        check_in_time: this.$t('check_in_time'),
        check_out_time: this.$t('check_out_time'),
        temperature: this.$t('temperature'),
      }]
      var doc = new jsPDF("portrait", "pt", "letter")
      var totalPagesExp = '{total_pages_count_string}'
      doc.autoTable({
        head: columns,
        body: this.aux2,
        didDrawPage: function (data) {
          // Header
          doc.setFontSize(20)
          doc.setTextColor(40)
          doc.setFontStyle('normal')
          // if (base64Img) {
          //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
          // }
          doc.text(headerInvitationSent, data.settings.margin.left + 20, 38)
          doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)

          // Footer
          var str = page + doc.internal.getNumberOfPages()
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === 'function') {
            str = str + de + totalPagesExp
          }
          doc.setFontSize(10)

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        allSectionHooks: true,
        didParseCell: function (data) {
          // if (data.row.index === 1) {
          //   data.cell.styles.fillColor = [40, 170, 100]
          // }
          if (data.row.section === 'body') {
            if (data.column.index === 1) {
              if(data.cell.text.toString() === '' || data.cell.text.toString() === ' ' || data.cell.text.toString() === null){
                data.cell.text = temperature
              }
            }
            if (data.column.index === 4) {
              if(data.cell.text.toString() === '' || data.cell.text.toString() === ' ' || data.cell.text.toString() === null){
                data.cell.text = temperature
              }
            }
            if (data.column.index === 5) {
              if(data.cell.text.toString() === '' || data.cell.text.toString() === ' ' || data.cell.text.toString() === null){
                data.cell.text = temperature
              }
            }
            if (data.column.index === 6) {
              if(data.cell.text.toString() === '' || data.cell.text.toString() === ' ' || data.cell.text.toString() === null){
                data.cell.text = temperature
              }
            }
          }
        },
        // willDrawCell: function (data) {
        //   if (data.row.section === 'body' && data.column.dataKey === 'temperature') {
        //     if (data.cell.raw > 37) {
        //       doc.setTextColor(255, 0, 0) // Red
        //     }
        //   }
        // },
        margin: { top: 80 }
      })
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      doc.save('healthFormat' + '_' + this.date + '_' + this.date2 + '.pdf')
    },
    async extra() {
      let base64Img = ''

      console.log('seccion = ', this.section2)
      switch (this.section2) {
        case 'kinder':
          // console.log('KINDERGARDEN')
          base64Img = this.dataSchool.logo_kindergarten
        break
        // case 'primaria':
        // break
        default:
          base64Img = this.dataSchool.logo
      }
      await this.exportPdfHealthByTeacherPayrollFormat (base64Img)
    },
    toDataUrl(url, callback) {
      var xhr = new XMLHttpRequest()
      xhr.onload = function() {
        var reader = new FileReader()
        reader.onloadend = function() {
          callback(reader.result)
        }
        reader.readAsDataURL(xhr.response);
      }
      xhr.open('GET', url)
      xhr.responseType = 'blob'
      xhr.send()
    },
    exportPdfHealthByTeacherPayrollFormat (base64Img) {
      this.loading = true
      var numRetardosPermitidos = 3
      var page = this.$t('page')
      var de = this.$t('de')
      var temperature = this.$t('sin_registrar')
      var Lunes = this.$t('Lunes')
      var Martes = this.$t('Martes')
      var Miercoles = this.$t('Miercoles')
      var Jueves = this.$t('Jueves')
      var Viernes = this.$t('Viernes')
      var Sabado = this.$t('Sabado')
      var Domingo = this.$t('Domingo')
      var nombre = this.$t('nombre') + ':'
      var nss = 'NSS:'
      var employee_number = this.$t('employee_no') + ':'
      var position = this.$t('position')
      var section = this.$t('section')
      var director = ''
      // console.log('Nombre completo = ', this.healthByTeacherPayrollRecords.data_teacher.fullname_teacher)
      // console.log('Nombre completo = ', this.healthByTeacherPayrollRecords.data_teacher.schedule_with_hours)
      // console.log('Nombre completo = ', this.healthByTeacherPayrollRecords.data_teacher.school_name)
      // console.log('Nombre completo = ', this.healthByTeacherPayrollRecords.data_teacher.address)
      // console.log('Nombre completo = ', this.healthByTeacherPayrollRecords.data_teacher.nss)
      var retardos = 'Retardos:'
      var faltas = 'Faltas:'
      var horario = this.$t('schedule') + ':'
      // var extended_schedule = this.$t('extended_schedule') + ':'
      // var headerDate = this.$t('fecha_hora')
      var columns = [{
        date: this.$t('date'),
        day: this.$t('day'),
        delay: '',
        check_in_time: this.$t('check_in_time'),
        check_out_time: this.$t('check_out_time'),
        check_in_time2: this.$t('check_in_time'),
        check_out_time2: this.$t('check_out_time'),
        observaciones: 'Observaciones',
      }]
      var doc = new jsPDF("portrait", "pt", "letter")
      var width = doc.internal.pageSize.getWidth()
      var totalPagesExp = '{total_pages_count_string}'

      for (let k = 0; k < this.healthByTeacherPayrollRecords.length; k++) {
        var teacher_name = this.healthByTeacherPayrollRecords[k].data_teacher.fullname_teacher
        // var horario_name = this.healthByTeacherPayrollRecords[k].data_teacher.schedule_with_hours
        var extra_schedule_teacher = this.healthByTeacherPayrollRecords[k].data_teacher.extra_schedule
        var school_name = this.healthByTeacherPayrollRecords[k].data_teacher.school_name
        var section_teacher= this.healthByTeacherPayrollRecords[k].data_teacher.section
        var school_address = this.healthByTeacherPayrollRecords[k].data_teacher.address
        var teacher_nss = this.healthByTeacherPayrollRecords[k].data_teacher.nss === null ? ''
            : this.healthByTeacherPayrollRecords[k].data_teacher.nss
        var teacher_employee_number = this.healthByTeacherPayrollRecords[k].data_teacher.employee_number === null ? ''
            : this.healthByTeacherPayrollRecords[k].data_teacher.employee_number
        var teacher_position = this.healthByTeacherPayrollRecords[k].data_teacher.position
        var principal_name = this.healthByTeacherPayrollRecords[k].data_teacher.principal_name
        let indexs = []
        let entry = {}
        let contRetardos = 0
        let contFaltas = 0
        for (let i = 0; i < this.healthByTeacherPayrollRecords[k].records.length; i++) {
          entry = {
            index: i,
            delay: this.healthByTeacherPayrollRecords[k].records[i].delay
          }
          indexs.push(entry)
          if (this.healthByTeacherPayrollRecords[k].records[i].delay === true) {
            contFaltas++
          }
          if (indexs[i].delay > (this.tolerance * 60)) {
            contRetardos++
          }
        }
        contFaltas += parseInt(contRetardos / numRetardosPermitidos)
        switch (section_teacher) {
          case 'kinder':
            director = this.$t('kindergarten_principal')
            section_teacher = 'Kinder'
            break
          case 'primaria':
            director = this.$t('elementary_principal')
            section_teacher = 'Primaria'
            break
          case 'secundaria':
            director = this.$t('middle_school_principal')
            section_teacher = 'Secundaria'
            break
          case 'preparatoria':
            director = this.$t('high_school_principal')
            section_teacher = 'Preparatoria'
            break
          case 'administrativo':
            director = this.$t('general_principal')
            section_teacher = 'Administrativo'
            break
          default:
            director = this.$t('general_principal')
            section_teacher = 'Desconocido'
        }
        doc.autoTable({
          columnStyles: {
            delay: {
              textColor: [255, 255, 255],
              fontSize: 1,
              cellWidth: 1
            },
            observaciones: {
              cellWidth: 150
            }
          },
          styles: {cellPadding: 0.5, fontSize: 10},
          theme: 'plain',
          head: columns,
          body: this.healthByTeacherPayrollRecords[k].records,
          didDrawPage: function (data) {
            // Header
            doc.setFontSize(12)
            doc.setTextColor(40)
            doc.setFontStyle('normal')
            doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 30, 100, 100)
            // doc.addImage(base64ImgIntrare, 'JPEG', data.settings.margin.left + 480, 30, 60, 50)
            doc.text(school_name, width / 2, 70, {align: 'center'})
            doc.setFontSize(8)
            doc.text(school_address, width / 2, 90, {align: 'center'})
            doc.setFontSize(10)

            doc.text(employee_number, data.settings.margin.left, 150)
            doc.text(teacher_employee_number, width/5, 150)
            doc.text(nombre, width/3, 150)
            doc.text(teacher_name, (width/2) - 40, 150)

            doc.text(section + ':', data.settings.margin.left, 165)
            doc.text(section_teacher, width/5, 165)
            doc.text(position + ':', width/3, 165)
            doc.text(teacher_position, (width/2) -40, 165)

            doc.text(nss, data.settings.margin.left, 180)
            doc.text(teacher_nss, width/5, 180)
            doc.text(retardos + ' ' + contRetardos, width/3, 180)
            doc.text(faltas + ' ' + contFaltas.toString(), (width/2) -40, 180)

            // doc.text(horario + ' ' + horario_name, data.settings.margin.left, 195)
            if (extra_schedule_teacher !== null)
            {
              doc.text(horario, data.settings.margin.left, 195)
              doc.text(extra_schedule_teacher, width/6, 195)
            }
            doc.text('______________________________', width / 4, 700, {align: 'center'})
            doc.text(principal_name, width / 4, 720, {align: 'center'})
            doc.text(director, width / 4, 740, {align: 'center'})
            doc.text('______________________________', (width / 4) * 3, 700, {align: 'center'})
            doc.text(teacher_name, (width / 4) * 3, 720, {align: 'center'})
            doc.text(teacher_position, (width / 4) * 3, 740, {align: 'center'})

            // Footer
            var str = page + doc.internal.getNumberOfPages()
            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === 'function') {
              str = str + de + totalPagesExp
            }
            doc.setFontSize(10)

            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = doc.internal.pageSize
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            doc.text(str, data.settings.margin.left, pageHeight - 10)
          },
          allSectionHooks: true,
          didParseCell: function (data) {
            if (data.row.section === 'body') {
              for (let i = 0; i < indexs.length; i++) {
                if (data.row.index === indexs[i].index) {
                  if (indexs[i].delay === true) {
                    data.cell.styles.fillColor = [255, 0, 0]
                  } else if (indexs[i].delay > 300) {
                    data.cell.styles.fillColor = [255, 255, 0]
                  }
                }
              }
              if (data.column.index === 1) {
                switch (data.cell.text.toString()) {
                  case '0':
                    data.cell.text = Lunes
                    break;
                  case '1':
                    data.cell.text = Martes
                    break;
                  case '2':
                    data.cell.text = Miercoles
                    break;
                  case '3':
                    data.cell.text = Jueves
                    break;
                  case '4':
                    data.cell.text = Viernes
                    break;
                  case '5':
                    data.cell.text = Sabado
                    break;
                  case '6':
                    data.cell.text = Domingo
                    break;
                }
              }
              if (data.column.index === 3) {
                if (data.cell.text.toString() === '' || data.cell.text.toString() === ' ' || data.cell.text.toString() === null) {
                  data.cell.text = temperature
                }
              }
              if (data.column.index === 4) {
                if (data.cell.text.toString() === '' || data.cell.text.toString() === ' ' || data.cell.text.toString() === null) {
                  data.cell.text = temperature
                }
              }
              if (data.column.index === 7) {
                if (data.cell.text.toString() === '' || data.cell.text.toString() === ' ' || data.cell.text.toString() === null) {
                  data.cell.text = '__________________________'
                }
              }
            }
          },
          willDrawCell: function (data) {
            if (data.row.section === 'body' && data.column.dataKey === 'delay') {
              if (data.cell.raw > 300) {
                doc.setTextColor(255, 0, 0) // Red
              }
            }
          },
          margin: {top: 250}
        })
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          doc.putTotalPages(totalPagesExp)
        }
        doc.addPage()
      }
      doc.save('payrollTeacher' + '_' + this.datePayrollInitial + '_' + this.datePayrollFinal+ '.pdf')
      this.loading = false
    },
    sectionFilter (value) {
      // If this filter has no value we just skip the entire filter.
      if (this.section === null || this.section === undefined) {
        return true
      }
      // Check if the current loop value (The calories value)
      // equals to the selected value at the <v-select>.
      return value.toLowerCase().includes(this.section.toLowerCase())
    },
    section2Filter (value) {
      // If this filter has no value we just skip the entire filter.
      if (this.section2 === null || this.section2 === undefined) {
        return true
      }
      // Check if the current loop value (The calories value)
      // equals to the selected value at the <v-select>.
      return value.toLowerCase().includes(this.section2.toLowerCase())
    },
    classroomFilter (value) {
      // If this filter has no value we just skip the entire filter.
      if (this.classroom === null || this.classroom === undefined) {
        return true
      }
      // Check if the current loop value (The calories value)
      // equals to the selected value at the <v-select>.
      return value.toLowerCase().includes(this.classroom.toLowerCase())
    },
    clearPayrollReport () {
      this.datePayrollInitial = this.datePayrollFinal = this.get_current_date()
      this.idTeacher = null
      this.healthByTeacherPayrollRecords = []
    }
  }
}
</script>

<style scoped>

</style>